import React, {Component} from 'react';
import { browserHistory } from 'react-router';

let HttpService = require('../Managers/HttpService');
let envConfig;

export default class CaseComplete extends Component {
    componentWillMount() {
        envConfig = HttpService.getConfigForHost();
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    render() {
        let refCase = JSON.parse(window.localStorage.getItem('Case'));

        let e2tapplications = [];
        let completeNowApplications = [];

        // Redirect to an error page if there's no Case data to submit
        if ( ! refCase) {
            browserHistory.push('/error/cannot-submit-case');
        }

        for (let i = 1; i <= refCase.numberOfTenants; i++) {
            if (window.localStorage.getItem('BaseIndividualApplication_' + String(i))) {
                let tenant = JSON.parse(window.localStorage.getItem('BaseIndividualApplication_' + String(i)));
                switch (tenant.completionMethod) {
                    case 1:
                        completeNowApplications.push(tenant);
                        break;
                    case 3:
                        e2tapplications.push(tenant);
                        break;
                }
            }
        }

        return(
            <div>
                <question-row class="header-row">
                    <h1>Referencing Case Submitted</h1>
                </question-row>

                <question-row class="header-row">
                    {e2tapplications.length >= 1 ?
                        <div>
                            <h3>Email to Tenant Applications</h3>
                            <p>The following tenants have been emailed the tenant link for them to complete</p>
                            <ul>
                            {
                                e2tapplications.map((tenant, i) => {
                                    return (
                                        <li key={tenant.firstName + tenant.email + i}><strong>{tenant.firstName} {tenant.lastName}</strong> {tenant.referenceNumber} </li>
                                    );
                                })
                            }
                            </ul>
                        </div>
                    : null }

                    {completeNowApplications.length >= 1?
                        <div>
                            <br />
                            <h3>Complete Now Applications</h3>
                            <p>Please complete the applications below by clicking the link for the relevant applicants</p>
                            <ul>
                            {
                                completeNowApplications.map((tenant, i) => {
                                    let url = envConfig.connectLandingAfterCompleteNow.url.replace("{applicationId}", tenant.applicationId);
                                    return (
                                        <li key={tenant.firstName + tenant.email + i}><strong>{tenant.firstName} {tenant.lastName}</strong> - <a className="btn btn-success" style={{display: 'inline-block'}} href={url}>Complete Now</a></li>
                                    );
                                })
                            }
                            </ul>
                        </div>
                    : null }
                </question-row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/CaseComplete.js